import React, { ErrorInfo, PropsWithChildren } from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export interface ErrorBoundaryComponentProps {
    error: Error;
    info: ErrorInfo;
    onReset: () => void;
}

interface ErrorProps {
    component?: React.ComponentType<ErrorBoundaryComponentProps>;
}

interface ErrorState {
    error: Error | undefined;
    info: ErrorInfo | undefined;
}

export class ErrorBoundary extends React.Component<
    PropsWithChildren<ErrorProps>,
    ErrorState
> {
    constructor(props: PropsWithChildren<ErrorProps>) {
        super(props);
        this.state = { error: undefined, info: undefined };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        this.setState({ error, info });
    }

    render() {
        if (this.state.error && this.state.info) {
            if (this.props.component) {
                const Component = this.props.component;
                return (
                    <Component
                        error={this.state.error}
                        info={this.state.info}
                        onReset={() =>
                            this.setState({ error: undefined, info: undefined })
                        }
                    />
                );
            }
            // You can render any custom fallback UI
            return <code>Error rendering children.</code>;
        }

        return this.props.children;
    }
}

export const SimpleErrorBoundary: React.FC = () => <ErrorOutlineIcon />;
